import OrganizationProgramEdit from 'src/components/Organization/pages/programs/edit';

export default OrganizationProgramEdit;
